module.exports = __webpack_public_path__ + "img/section01.8bf7afa4.png";